import { Divider, Typography } from "@mui/material";
import React, { useState } from "react";
import Categories from "./Categories";
import Dishes from "./Dishes";

const OrderRightContent = () => {
  const [category, setCategory] = useState("Salad");

  return (
    <div style={{ maxWidth: "743px" }}>
      <Categories selectCategory={(e) => setCategory(e)} />

      <Typography
        align="left"
        style={{
          color: "#424242",
          fontWeight: "600",
          fontFamily: `'Noto Sans', sans-serif`,
        }}
      >
        {category}
      </Typography>
      <CustomeDivider />

      <Dishes />
    </div>
  );
};

const CustomeDivider = () => (
  <div style={{ paddingBottom: "20px", paddingTop: "7px" }}>
    <Divider
      style={{
        background: "#E5E5E5",
        margin: "0 0 0 0",
        maxWidth: "100%",
        height: "2.25px",
      }}
    />
    <Divider
      style={{
        background: "#CA2129",
        margin: "-3px 0 0 0",
        maxWidth: "151px",
        height: "3px",
      }}
    />
  </div>
);

export default OrderRightContent;
